
import MUIDataTable from 'mui-datatables'
import { Link } from 'react-router-dom';
import axiosInstance from '../../../axiosInstance';
import "../../../css/Users.css"
import { containsPermission, logOut } from '../../helper';
import React, {Component} from 'react';
import { Form, Col } from 'react-bootstrap';


const columns = [
    {
        "name" : "display_name",
        "label" : "როლი",
        "options": {
            "sort" : true
        }
    },
    
]
class Problems extends Component {
    constructor(){
        super();
        this.onRowsDelete = this.onRowsDelete.bind(this);
        this.state = {
            data:[],
            options:{
                serverSide:true,
                filterType: 'checkbox',
                selectableRowsHeader:false,
                expandableRowsHeader:false,
                viewColumns:false,
                print:false,
                filter:false,
                selectableRows:'multiple',
                onRowsDelete:this.onRowsDelete
            },
            response : {
                isValid : false,
                isInValid:false,
                message : 'პრობლემა წარმატებით ჩაემატა'
            }
        }

        
    }
    componentDidMount(){
        this.fetch_problems();
    }


    
    onRowsDelete(rowsDeleted){
        let deleted_rows  = rowsDeleted.data.map(element => this.state.data[element.dataIndex]);
        var data = new FormData();  
        data.append('deleted_problems',deleted_rows);
        axiosInstance.delete('/problems', {
            data: {
                deleted_problems: deleted_rows
            }
        })
        .then(response=>this.on_problem_deleted(response.data))
        .catch(error => {
            if(error.response.status == 400){
                this.on_bad_request(error.response.data);
            }
        });

        return false;
        
    }

    on_problem_deleted(data){
        this.fetch_problems();
    }

    on_bad_request(data){
        // message = data.map()
        this.setState({
            response:{
                ...this.state.response,
                isInValid:true,
                message:data.messages
            }
        })
    }


    fetch_problems(){
        axiosInstance.get('/problems')
        .then(response=>this.on_fetch_problems(response.data))
        .catch(err => {
            if(err.response !== null){
                if(err.response.status === 401){
                    logOut(this.props);
                }
            }
        })
    }

    on_fetch_problems(data){
        this.setState({
            data:data
        })
    }


    render(){

        let add_problem = null;
        if(containsPermission(this.props.role_permissions,'roles.add')){
            add_problem = <Link  to = "/problems/new_problem"  id = "create_new_btn" className="btn btn-dark" > ახლის დამატება</Link>;
        }
        return (
            <div className = "content-main">
                <Form.Row>
                        <Form.Group as={Col}  md="4" >
                            <Form.Control
                                    problem="text"
                                    name="problem"
                                    hidden = {true}
                                    isInvalid = {Boolean(this.state.response.isInValid)}
                                    isValid = {Boolean(this.state.response.isValid)}
                                    onChange = {null}
                                />
                            <Form.Control.Feedback type="invalid" >
                                {this.state.response.message}
                            </Form.Control.Feedback>

                            <Form.Control.Feedback >
                                {this.state.response.message}
                            </Form.Control.Feedback>
                        </Form.Group>
                </Form.Row>
                {add_problem}
                <MUIDataTable
                    data={this.state.data}
                    columns={columns}
                    options={this.state.options}
                />
            </div>
        )
    }
}
export default Problems;